// 옵션명 표시 포맷 유틸

// 호스 옵션("앞*뒤" 또는 "앞x뒤")을 "앞mm x 뒤M" 형태로 변환.
// 예: 13*70 → 13mm x 70M, 8.5*100 → 8.5mm x 100M. (호스 외 옵션명은 그대로 반환)
export function formatOptionName(name?: string | null): string {
  if (!name) return '';
  const m = name.match(/^\s*([\d.]+)\s*[*x×]\s*([\d.]+)\s*$/i);
  return m ? `${m[1]}mm x ${m[2]}M` : name;
}

// 한국어 목적격 조사: 받침 있으면 '을', 없으면 '를'. (한글이 아니면 '를')
export function objectParticle(word?: string | null): string {
  if (!word) return '를';
  const code = word.charCodeAt(word.length - 1);
  if (code >= 0xac00 && code <= 0xd7a3) {
    return (code - 0xac00) % 28 === 0 ? '를' : '을';
  }
  return '를';
}

// 가격 표기. 한국어: "1,234,000원", 영어: "USD 1,234" (KRW 1,000 ≈ USD 1 로 환산, 천 단위 절삭)
// 영문 전용 배포 요청: 원화 금액에서 뒤 000을 떼고 USD 로 표기.
export function formatPrice(price: number, lang: 'ko' | 'en'): string {
  if (lang === 'ko') return `${price.toLocaleString('ko-KR')}원`;
  return `USD ${Math.round(price / 1000).toLocaleString('en-US')}`;
}
